import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import GoogleMapReact from 'google-map-react';
//import { MarkerIcon } from '@components/icon/icon';
//import { connectHits } from 'react-instantsearch-dom';


import Marker from './resultsmarker';
// import { mapStyles } from "./constants"
//import {NoResultProperties, NoResultPropertiesAuctions} from '../../queries/common_use_query';

function MapsInfiniteHits(props) {
  const [mapenable, setMapenable] = useState(false);
  const [render, setRender] = useState(false);

  const [mapmarkers, setMapmarkers] = useState([]);
  const [currentId, setCurrentId] = React.useState("");
  const [hits, setHits] = React.useState([]);
  const [noHits, setNoHits] = React.useState([]);
  const [zoom, setZoom] = React.useState(11);

  var no_properties =  props.noResultProperties?.length > 0 && props.noResultProperties.filter(item => item.latitude && item.longitude)

  // const {loading:loading, error:error, data:no_data} = props.status ? NoResultProperties(props.status, props.department) : NoResultPropertiesAuctions(props.department);

  //console.log("props_hits", props.hits, no_data);

  //console.log("noResultProperties", no_properties);


  const [center, setCenter] = React.useState({ lat: no_properties.length > 0 ? no_properties[0].latitude : 51.509865, lng: no_properties.length > 0 ? no_properties[0].longitude : -0.118092 });

//   if(hits != props.hits) {
//     setRender(false)
//     setHits([])

//     var mapmarkersarr = props.hits && props.hits?.filter(hit => hit._geoloc?.lat);

//     var hits_arra = mapmarkersarr;

//     //console.log("props_hits",hits_arra)
    
//     if (props.hits.length <= 0) {
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }})
//     } if (mapmarkersarr.length <= 4) {
//       // console.log("xxx1",props.hits[0])
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: parseFloat(hits_arra[0]?._geoloc?.lat) + 0.008, lng: parseFloat(hits_arra[0]?._geoloc?.lng) + 0.008 }})
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: parseFloat(hits_arra[0]?._geoloc?.lat) - 0.009, lng: parseFloat(hits_arra[0]?._geoloc?.lng) - 0.009 }})
//     }


//     //setHits(props.hits)

//     // var loc_arr = props.hits.length > 0 ? props.hits : [{ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }}]
//     setHits(props.hits)
//     setTimeout(() => {
//       setRender(true)      
//     }, 200);

// }

useEffect(()=>{
  setRender(false)
  setHits(props.algoliadata?.hits)
  //setNoHits([{ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }}])
  setTimeout(() => {
    setRender(true)      
  }, 200);
},[props.algoliadata?.hits])

// useEffect(()=>{
//   var no_hits = []
//   if(props.hits.length === 0){
//     no_data?.properties?.length > 0 && no_data?.properties?.map((item => no_hits.push({objectID: item.id, _geoloc:{lat: item.latitude, lng: item.longitude} })))

//     setHits(no_hits); setZoom(9);
//   }
// },[props.hits, no_data])

useEffect(()=>{
  (hits && hits?.length > 4) ? setZoom(9) : setZoom(9);
},[hits])


  const mygetMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();

    places.forEach((place) => {
      bounds.extend(new maps.LatLng(
        place._geoloc?.lat,
        place._geoloc?.lng,
      ));
    });
    return bounds;
  };

  // Re-center map when resizing the window
  const mybindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds);
      });
    });
  };

  // Fit map to its bounds after the api is loaded
  const myapiHasLoaded = (map, maps, places) => {
    // Get bounds by our places
    const bounds = mygetMapBounds(map, maps, places);
    // Fit map to bounds
    map.fitBounds(bounds);
    // Bind the resize listener
    mybindResizeListener(map, maps, bounds);
  };

  //console.log("hits ==>", zoom, hits);

  return (
    <div id="map" className="map">
      {render &&
      <GoogleMapReact
          bootstrapURLKeys={{ 
            key: `${process.env.GATSBY_MAPS_API_KEY}`
            //key: ""
          }}
          options={{ styles: "" }}
          center={center}
          //zoom={hits?.filter(hit => hit?._geoloc?.lat).length > 0 ? zoom : 9}
          zoom={zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => hits?.filter(hit => hit?._geoloc?.lat).length > 0 &&  myapiHasLoaded(map, maps, hits?.filter(hit => hit?._geoloc?.lat))}
      >
        {hits?.length > 0 && (hits?.filter(hit => hit?._geoloc?.lat).map((pnt,ind) => {
          
          if(pnt._geoloc?.lat && pnt._geoloc?.lng){
            return(<Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={pnt.objectID} currentId={currentId} setCurrentId={setCurrentId}/>)
          }
          
          }
        ))
          // :
          // (noHits?.filter(hit => hit?._geoloc?.lat).map((pnt,ind) => <Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={pnt.objectID} currentId={currentId} setCurrentId={setCurrentId}/>))
        }
      </GoogleMapReact>
      }
    </div>
  );
}

//const MapContainer = connectHits(MapsInfiniteHits)

//export default React.memo(MapContainer);

export default MapsInfiniteHits;